export default __webpack_public_path__ + "static/media/maintenance_request_character.cc441d87.svg";